import React from "react";
import { Box, Typography, Avatar } from "@mui/material";
import styled from "@emotion/styled";
import { formattedAmountWithoutAed } from "../../../../../../utils/CommonFunction";
import { ReactComponent as ArrowIcon } from "../../../../../../assets/svg/ArrowIcon.svg";
import { renderCurrencyIcon } from "../../../../../../utils/CurrencyUtils";

const NO_IMAGE_SRC =
  "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b";

const Container = styled(Box)`
  display: flex;
  width: 100%;
  align-items: center;
`;

const BudgetBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f7f7f7;
  border-radius: 12px;
  padding: 8px 16px;
  width: 100%;
`;

const Column = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const BudgetRow = ({ budget }) => {
  return (
    <Container>
      <ArrowIcon
        size={40}
        className="text-gray-300"
        style={{ marginLeft: 16, marginRight: -8 }}
      />
      <BudgetBox>
        <Box display="flex" alignItems="center" gap={1} width="12.5%">
          <Avatar
            src={budget?.buget_image?.[0]?.image || NO_IMAGE_SRC}
            sx={{ width: 24, height: 24 }}
            variant="rounded"
          />
          <Typography variant="body2">{budget.name}</Typography>
        </Box>

        <Column sx={{ width: "12.5%" }}>
          <Typography fontWeight={500} variant="caption" color="text.secondary">
            Material Type
          </Typography>
          <Typography variant="body2">{budget?.materialType || "-"}</Typography>
        </Column>

        <Column sx={{ width: "12.5%" }}>
          <Typography fontWeight={500} variant="caption" color="text.secondary">
            Material Unit
          </Typography>
          <Typography variant="body2">{budget?.materialUnit || "-"}</Typography>
        </Column>

        <Column sx={{ width: "12.5%", alignItems: "flex-end" }}>
          <Typography
            fontWeight={500}
            variant="caption"
            color="text.secondary"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            Unit Cost ({renderCurrencyIcon("mweb")})
          </Typography>
          <Typography variant="body2">
            {formattedAmountWithoutAed(budget?.materialUnitPrice) || "-"}
          </Typography>
        </Column>

        <Column sx={{ width: "12.5%", alignItems: "center" }}>
          <Typography fontWeight={500} variant="caption" color="text.secondary">
            Units
          </Typography>
          <Typography variant="body2">{budget?.quantity || "-"}</Typography>
        </Column>

        <Column sx={{ width: "12.5%", alignItems: "center" }}>
          <Typography fontWeight={500} variant="caption" color="text.secondary">
            Manpower Rate
          </Typography>
          {console.log(budget, "budget")}
          <Typography variant="body2">{budget?.manpowerRate || "-"}</Typography>
        </Column>

        <Column sx={{ width: "12.5%", alignItems: "center" }}>
          <Typography fontWeight={500} variant="caption" color="text.secondary">
            Days
          </Typography>
          <Typography variant="body2">{budget?.days || "-"}</Typography>
        </Column>

        <Column sx={{ width: "12.5%", alignItems: "flex-end" }}>
          <Typography
            fontWeight={500}
            variant="caption"
            color="text.secondary"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            Amount ({renderCurrencyIcon("mweb")} )
          </Typography>
          <Typography variant="body2">
            {budget.totalPrice
              ? formattedAmountWithoutAed(budget.totalPrice)
              : "-"}{" "}
          </Typography>
        </Column>
      </BudgetBox>
    </Container>
  );
};

export default BudgetRow;
